import JobLifecyclePage from '@/pages/jobs/lifecycle'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventLifecyclePage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobLifecyclePage />
    </WorkspacePortalProvider>
  )
}
